module.exports = __webpack_public_path__ + "img/ss_ye-05.85e25f37.jpg";